import React from 'react';
import { Divider } from 'antd';
import { MultiLangInput } from './shared/MultiLangInput';

export const LegalTextsSettings: React.FC = () => {
  return (
    <>
      <Divider orientation="left">Условия доставки</Divider>
      <MultiLangInput
        namePrefix="delivery_terms"
        label="Условия доставки"
        type="textarea"
        rows={6}
      />

      <Divider orientation="left">Условия оплаты</Divider>
      <MultiLangInput
        namePrefix="payment_terms"
        label="Условия оплаты"
        type="textarea"
        rows={6}
      />

      <Divider orientation="left">Как заказать</Divider>
      <MultiLangInput
        namePrefix="how_to_order"
        label="Инструкция по заказу"
        type="textarea"
        rows={6}
      />

      <Divider orientation="left">Политика конфиденциальности</Divider>
      <MultiLangInput
        namePrefix="privacy_policy"
        label="Политика конфиденциальности"
        type="textarea"
        rows={8}
      />

      <Divider orientation="left">Условия использования</Divider>
      <MultiLangInput
        namePrefix="terms_of_use"
        label="Условия использования"
        type="textarea"
        rows={8}
      />

      {/* ✨ НОВАЯ СЕКЦИЯ: Оферта для Амбассадоров */}
      <Divider orientation="left">Оферта для Амбассадоров</Divider>
      <MultiLangInput
        namePrefix="ambassador_offer" // Префикс соответствует полям ambassador_offer_ru/kz/en в модели
        label="Текст Оферты для Амбассадоров"
        type="textarea"
        rows={8}
      />
    </>
  );
};